/**
 * Created by caterina on 04-05-17.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {FolderService} from './folder.service';
import {RouterModule} from '@angular/router';
import {FolderListComponent} from './folder-list/folder-list.component';
import {NavModule} from '../_shared/nav/nav.module';
import {FoldersViewComponent} from './folders-view/folders-view.component';
import {ProjectModule} from '../project/project.module';
import {MoveModalComponent} from './move-modal/move-modal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NavModule,
        ProjectModule
    ],
    exports: [
        FoldersViewComponent,
        FolderListComponent
    ],
    declarations: [
        FolderListComponent,
        FoldersViewComponent,
        MoveModalComponent
    ],
    providers: [FolderService]
})
export class FolderModule {
}



// WEBPACK FOOTER //
// ./src/app/folder/folder.module.ts